import ManageUsers from "../../features/userProfile/manageUsers";
import style from "./AboutUsAndLegal.module.scss";
import AccountHeader from "./AccountHeader";
import useSalesforce from "../../hooks/useSalesforce";
import SalesforceManageUsers from "../../features/userProfile/SalesforceManageUsers";
import useAuth from "../../hooks/useAuth";

const ManageAppUsers = () => {
  const { userProfile: profileData } = useAuth();
  const { isSalesforceEnabled, isSubscribeEnabled } = useSalesforce();

  return (
    <div className={style.container}>
      <AccountHeader headername="Manage Users" />
      {isSalesforceEnabled && isSubscribeEnabled ? (
        <SalesforceManageUsers
          subscriptions={profileData?.subscriptions || []}
          mainAccountContact={profileData?.contact}
        />
      ) : (
        <ManageUsers
          subscriptions={profileData?.subscriptions || []}
          mainAccountContact={profileData?.contact}
        />
      )}
    </div>
  );
};

export default ManageAppUsers;
